import { ResponsesFixedIncomeDetailsPositionResponse } from '@genial/services/dist/models';
import { Utils } from '@genial/utils';

import { objectIsEmpty } from '../../../utils/objectIsEmpty';
import { FixedIncomeWithdrawAssetNormalized } from '../types';

export const normalizeFixedIncomeWithdrawGetFixedIncomeAsset = (
  data: ResponsesFixedIncomeDetailsPositionResponse
): FixedIncomeWithdrawAssetNormalized => {
  if (objectIsEmpty(data)) {
    throw new Error('No Fixed Income found');
  }

  return {
    ...data,
    isDailyLiquidity: !!data.dailyLiquidity,
    productNameNormalized: data.issuerFullName || '--',
    buyTaxNormalized: data.rateText || '--',
    maturityDateFormatted: data.expirationDate
      ? Utils.Mask.DateFormat(data.expirationDate as unknown as Date, 'dd/MM/yyyy')
      : '--',
    contributionsTotalNormalized: data.purchaseValue ? Utils.Mask.Money(data.purchaseValue) : '--',
    iofValueNormalized: Utils.Mask.Money(data.iof),
    irValueNormalized: Utils.Mask.Money(data.ir),
    rentabilityNormalized: data.returnValue ? Utils.Mask.Percentage(data.returnValue) : '--',
    grossTotalValueNormalized: data.grossValue ? Utils.Mask.Money(data.grossValue) : '--',
    quantityNormalized: (data.availableQuantity || 0).toString(),
    unitValueNormalized: data.currentPrice ? Utils.Mask.Money(data.currentPrice) : '--',
    exitTaxNormalized: '--', // olhar arquivo do legado
    currentPriceNormalized: data.currentPrice || 0,
  };
};
